import createSlider from '@/js/helpers/create-slider'
import docReady from '@/js/helpers/doc-ready'

docReady(() => {
  const uspSliders = document.querySelectorAll('.usp-slider')

  const uspSlidersParams = {
    percentPosition: true,
    autoPlay: 3500,
    draggable: false
  }

  if (uspSliders) {
    for (let i = 0; i < uspSliders.length; i++) {
      createSlider(uspSliders[i], uspSlidersParams)
    }
  }

  const categoriesSliders = document.querySelectorAll('.categories-slider, .general-sidebar__activities')
  const categoriesSlidersParams = {
    groupCells: true,
    percentPosition: true
  }

  if (categoriesSliders) {
    for (let i = 0; i < categoriesSliders.length; i++) {
      createSlider(categoriesSliders[i], categoriesSlidersParams)
    }
  }

  const arrangementsCards = document.querySelectorAll('.l-cards__slider--arrangements, .arrangement-menus')
  const arrangementsCardsParams = {
    percentPosition: true,
    cellAlign: 'left',
    draggable: '>1'
  }

  if (arrangementsCards) {
    for (let i = 0; i < arrangementsCards.length; i++) {
      createSlider(arrangementsCards[i], arrangementsCardsParams)
    }
  }

  const cardsSliders = document.querySelectorAll('.l-cards__slider--regular, .l-reviews__slider')
  const cardsSlidersParams = {
    percentPosition: true,
    watchCSS: true,
    cellAlign: 'left',
    draggable: '>1'
  }

  if (cardsSliders) {
    for (let i = 0; i < cardsSliders.length; i++) {
      createSlider(cardsSliders[i], cardsSlidersParams)
    }
  }

  const largeSlider = document.querySelector('.large-slider')
  const largeSliderParams = {
    percentPosition: true,
    freeScroll: false,
    wrapAround: true,
    contain: false
  }

  if (largeSlider) {
    createSlider(largeSlider, largeSliderParams)
  }
})
